module.exports = __webpack_public_path__ + "static/media/pic2.046f36f0.jpg";